import { combineReducers } from 'redux';
import routing from './routing';
import quote from './quote'
import personalDetails from './personalDetails'
import uploadDocuments from './uploadDocuments'
import bankingDetails from './bankingDetails';
import referenceData from './referenceData';
export const kaMetlhaFuneralCover = combineReducers({
    quote,
    personalDetails,
    routing,
    uploadDocuments,
    bankingDetails,
    referenceData
});
